import { useAtom, useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";

import { Modal } from "@/components/Interface/Modal/Modal";
import {
  clearAuthAtom,
  isAnonymousUserAtom,
  showsSessionExpiredModalAtom,
  verifierAtom,
} from "@/utils/atoms";
import { generateVerifier } from "@/utils/authentication";

import { Button } from "./Interface/Button/Button";

export const SessionExpiredModal = () => {
  const [show, setShow] = useAtom(showsSessionExpiredModalAtom);
  const setShowSessionExpiredModal = useSetAtom(showsSessionExpiredModalAtom);
  const [, setVerifier] = useAtom(verifierAtom);
  const [isAnonymousUser] = useAtom(isAnonymousUserAtom);
  const clearAuth = useSetAtom(clearAuthAtom);
  const { t } = useTranslation();

  const handleLoginRedirect = async () => {
    try {
      setShow(false);
      setShowSessionExpiredModal(undefined);

      // Clear auth tokens from localStorage (via atomWithStorage) so that
      // usePartnerLoginRedirect does not auto-redirect back to the cockpit
      // with stale credentials after the page reloads.
      clearAuth();

      // Generate new verifier for the login flow
      const newVerifier = generateVerifier();
      setVerifier(newVerifier);

      const isPartnerRoute =
        window.location.hash.startsWith("#/partner") ||
        window.location.hash.startsWith("#/welcome-partner");
      window.location.assign(
        isPartnerRoute ? "/#/welcome-partner" : "/#/welcome",
      );
    } catch (error) {
      console.error(error);
    }
  };

  // Don't show the modal for anonymous users
  if (!show || isAnonymousUser) return null;

  return (
    <Modal
      title={t("sessionExpired.title")}
      onClose={() => {}}
      showCloseButton={false}
    >
      <div style={{ minWidth: 300, minHeight: 80 }}>
        <>
          <p>{t("sessionExpired.text")}</p>
          <div style={{ display: "flex", gap: "10px", marginTop: "16px" }}>
            <Button
              fullWidth
              className="accent inverted text-sm"
              onClick={handleLoginRedirect}
            >
              {t("sessionExpired.backToHome")}
            </Button>
          </div>
        </>
      </div>
    </Modal>
  );
};
